import moment from 'moment';

export default {
    methods: {
        getAnimalsWithHeat(animals) {
            let result = [];
            let tmpHeats =  animals.filter(animal => animal.calving.date);
            tmpHeats.forEach(animal => {
                for (let i = 1; i < 7; i++) {
                    let max = moment().subtract((i * 21) - 3, 'd');
                    let min = moment().subtract((i * 21) + 3, 'd');
                    console.log(animal.key);
                    if (moment(animal.calving.date).isBetween(min, max)) {
                        let diff = moment(animal.calving.date).diff(min, 'd');
                        animal.heatCycle = i;
                        animal.heatDay = diff + 18;
                        result.push(animal);
                    }
                }
            });
            return result;
        }
    }
}